import { render, staticRenderFns } from "./EmployeeHeader.vue?vue&type=template&id=978020e4&"
import script from "./EmployeeHeader.vue?vue&type=script&lang=js&"
export * from "./EmployeeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports